import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, catchError, finalize, tap, throwError } from 'rxjs';
import { NotificationService } from './notification.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { AspiranteService } from 'src/app/pages/aspirante/services/aspirante.service';

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  private spinnerVisible = false;

  constructor(
    private spinner: NgxSpinnerService,
    private notificationService:NotificationService,
    private _router: Router,
    private _aspiranteService: AspiranteService,
    ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.spinnerVisible) {
      this.spinnerVisible = true;
      this.spinner.show();
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (event.body && event.body.data) {
            this.hideSpinner();
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.notificationService.error('No tienes permiso para hacer esto', 'PERMISO DENEGADO')

          const esUsuarioAutenticadoJWT: boolean = this._aspiranteService.esUsuarioAutenticadoJWT();

          if(esUsuarioAutenticadoJWT){
            const jwtHelper = new JwtHelperService();
            const token = localStorage.getItem('jwt');
            const decodedToken = jwtHelper.decodeToken(token);
            const link = `aspirante/registro/perfil/${decodedToken.sub}`;
            this._router.navigate([link]);
          }
          else{
            this._router.navigate(['/admin/registros']);
          }
          setTimeout(() => {
            window.location.reload()
          }, 1500);
        }
        return throwError(error);
      }),
      finalize(() => {
        this.hideSpinner();
      })
    );
  }

  private hideSpinner() {
    if (this.spinnerVisible) {
      this.spinnerVisible = false;
      setTimeout(() => {
        this.spinner.hide();
      }, 1000);
    }
  }
}
